export const handleUpload = async (file, location, logUser, logLocation , referenceNo , referenceType) => {

    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('location', location);
        formData.append('logUser', logUser);
        formData.append('logLocation', logLocation);
        formData.append('referenceNo', referenceNo);
        formData.append('referenceType', referenceType);

        let requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${authToken}`
            },
            body: formData,
            redirect: 'follow'
        };

        const response = await fetch(`${ApiURL}txn/generate_txn`, requestOptions);
        const result = await response.json();
        if (response.ok) {
            if (result.success) {
                return { success: true, message: result.message }
            } else {
                return { success: false, message: result.message }
            }
        } else {
            console.error('Error uploading file:', response.statusText);
            return { success: false, message: result.message }
        }
    } catch (error) {
        console.error('Error:', error.message);
        return { success: false, message: error.message }
    }


};


export const GetUserWiseLocations = async (username, logLocation) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            redirect: 'follow',
            body: JSON.stringify({
                "Username": username,
                "LogLocation": logLocation
            })
        };

        const response = await fetch(`${ApiURL}Locations/userwise/locations`, requestOptions);
        const result = await response.json();

        if (result.success) {
            return { success: true, data: result.data };
        }

        return { success: false, data: result.data };
    } catch (error) {
        console.error("BincardGet error:", error);
        return { success: false, data: [] };
    }
};


export const GetTxnDropdown = async () => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    try {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        const response = await fetch(`${ApiURL}txn/dropdown`, requestOptions);
        const result = await response.json();

        if (response.ok) {
            if (result.success) {
                return { success: true, data: result.data };
            } else {
                return { success: false, data: [] };
            }
        }
        return { success: false, data: [] };
    } catch (error) {
        console.log('Error:', error);
        return { success: false, data: [] };
    }
}
